var exports = {
  "kL": "xe564cbfb--1b2f38--container",
  "UJ": "xe564cbfb--1b2f38--content-container",
  "e": "xe564cbfb--1b2f38--text-container",
  "Sl": "xe564cbfb--1b2f38--image",
  "ic": "xe564cbfb--1b2f38--image--with-image",
};

module.exports = exports;
